module.exports = __webpack_public_path__ + "static/media/ss-banner-583x299-012424.690e417f.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/ss-banner-583x299-012424.png
// module id = 1306
// module chunks = 0